import {createContext} from 'react';

export interface ContextualOptionsScope {
  targetItemIds: string[];
}

export const ContextualOptionsScopeContext = createContext<ContextualOptionsScope | null>(null);
